import React from 'react';
import {Link, withRouter } from 'react-router-dom';
import notFoundImg from '../../images/not-found.png'

@withRouter
export default class NotFound extends React.Component{
    render(){
        return(
            <section className="not-found section-center">
                <div className="section-center-wrapper">
                    <h3 className="title">Ooops…page not found</h3>
                    <img src={notFoundImg} alt="Not found"/>
                    <p className="desc">The page you are looking for doesn’t exist or has been moved</p>
                    <div className="button-set">
                        <Link
                            to='/'
                            className="btn blue rounded">
                            Home
                        </Link>
                    </div>
                </div>
            </section>
        )
    }
}







// WEBPACK FOOTER //
// ./src/modules/blocks/404.js